export default __webpack_public_path__ + "static/media/FooterLogo.bb28e12a.png";